import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { APIUrl, APIUrlToken, getIsUser } from "../../Utils/Utils";
import axios from "axios";
import Loader from "../../Components/Loader/Loader";
import moment from "moment";
import "../AthleteDashboard/AdminDashboard.css";
import AthletePricingDashboard from "./AthletePricingDashboard";
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";
import { ImCross } from "react-icons/im";
import { FaUser } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
const AthleteDashboard = () => {
  const userData = getIsUser();
  const [activeMainTab, setActiveMainTab] = useState("dashboard");
  const [activePricingTab, setActivePricingTab] = useState("fan");
  const [transactions, setTransactions] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [viewMoreDetail, setViewMoreDetail] = useState();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      "(min-width: 320px) and (max-width: 767px)"
    );
    setIsMobile(mediaQuery.matches);
    const handleResize = () => setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleResize);
    return () => mediaQuery.removeEventListener("change", handleResize);
  }, []);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? 280 : 600,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: isMobile ? 2 : 4,
    outline: "none",
  };
  const [openDetailModal, setOpenDetailModal] = React.useState(false);
  const handleOpenDetails = (item) => {
    setViewMoreDetail(item);
    setOpenDetailModal(true);
  };
  const handleCloseDetails = () => {
    setViewMoreDetail("");
    setOpenDetailModal(false);
  };
  // Fetch athlete transactions
  useEffect(() => {
    if (!userData?.player_id) return;
    const fetchTransactions = async () => {
      try {
        const res = await axios.get(`${APIUrl()}/v1/transactions/by_player`, {
          headers: {
            "X-API-Key": APIUrlToken(),
          },
          params: {
            player_id: userData.player_id,
          },
        });

        setTransactions(res.data.transactions || []);
        setTotalAmount(res.data.total_amount || 0);
      } catch (error) {
        console.error("Failed to fetch player transactions", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTransactions();
  }, [userData?.player_id]);

  return (
    <div>
      {loading && <Loader />}
      <Header />
      <div className="admin-dashboard-container">
        <h2 className="admin-dashboard-title">Athlete Dashboard</h2>

        {/* Main Tabs */}
        <div className="admin-tabs">
          <div
            className={`admin-tab ${
              activeMainTab === "dashboard" ? "active" : ""
            }`}
            onClick={() => setActiveMainTab("dashboard")}
          >
            Athlete Dashboard
          </div>
          <div
            className={`admin-tab-pricing ${
              activeMainTab === "pricing" ? "active" : ""
            }`}
            onClick={() => setActiveMainTab("pricing")}
          >
            Pricing
          </div>
        </div>

        {/* Panel Content */}
        <div className="admin-panel-content">
          {activeMainTab === "dashboard" && (
            <div className="admin-dashboard-section">
              {transactions.length > 0 ? (
                <>
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Transaction Amount</th>
                        {/* <th>Transaction Type</th>  */}
                        <th>Payment Method</th>
                        {/* <th>Recurring Duration</th> */}
                        <th>Date Received</th>
                        <th>More Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.map((txn, index) => (
                        <tr key={txn.transaction_id}>
                          <td>{index + 1}</td>
                          <td>${txn.transaction_amount}</td>
                          {/* <td>{txn.transaction_type || "-"}</td>  */}
                          <td>{txn.payment_method_type || "-"}</td>
                          {/* <td>
                            {txn.recurring_cost_duration > 0
                              ? `${txn.recurring_cost_duration} months`
                              : "-"}
                          </td> */}
                          <td>
                            {txn.created_at
                              ? moment(txn.created_at).format("MM/DD/YYYY")
                              : "-"}
                          </td>
                          <td
                            style={{
                              cursor: "pointer",
                              textDecoration: "underline",
                              color: "blue",
                            }}
                            onClick={() => handleOpenDetails(txn)}
                          >
                            Click here
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="admin-total-row">Total: ${totalAmount}</div>
                </>
              ) : (
                <div className="admin-no-results">No Transactions Found</div>
              )}
            </div>
          )}

          <AthletePricingDashboard
            activeMainTab={activeMainTab}
            activePricingTab={activePricingTab}
            setActivePricingTab={setActivePricingTab}
            userData={userData}
          />
        </div>
      </div>
      <Footer />

      <Modal open={openDetailModal} onClose={handleCloseDetails}>
        <Box sx={style}>
          <div>
            <div className="fan-content">
              <div className="fan-step">
                <h3
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {viewMoreDetail?.brand_engagement ? "Brand" : "Fan"} {""}
                  Checkout Details &amp; Payment{" "}
                  <ImCross
                    style={{ cursor: "pointer" }}
                    onClick={handleCloseDetails}
                  />
                </h3>
                <div className="section-title-accountInfo">Primary Details</div>
                <div className="first-section-my-profile">
                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <FaUser />
                      </div>
                      <input
                        className="form-control-accountInfo"
                        placeholder="First Name"
                        type="text"
                        value={
                          viewMoreDetail
                            ? viewMoreDetail?.brand_engagement
                              ? viewMoreDetail?.brand_engagement
                                  ?.user_first_name
                              : viewMoreDetail?.fan_engagement?.user_first_name
                            : null
                        }
                        disabled
                        name="firstname"
                      />
                    </div>
                  </div>
                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <FaUser />
                      </div>
                      <input
                        className="form-control-accountInfo"
                        placeholder="Last Name"
                        type="text"
                        value={
                          viewMoreDetail
                            ? viewMoreDetail?.brand_engagement
                              ? viewMoreDetail?.brand_engagement?.user_last_name
                              : viewMoreDetail?.fan_engagement?.user_last_name
                            : null
                        }
                        disabled
                        name="lastname"
                      />
                    </div>
                  </div>
                </div>
                <div className="first-section-my-profile-company">
                  <div className="input-section-accountInfo-company">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <FaUser />
                      </div>
                      <input
                        className="form-control-accountInfo"
                        placeholder="Company Name"
                        type="text"
                        value={
                          viewMoreDetail
                            ? viewMoreDetail?.brand_engagement
                              ? viewMoreDetail?.brand_engagement?.brand_name
                              : viewMoreDetail?.fan_engagement?.brand_name
                            : null
                        }
                        disabled
                        name="companyname"
                      />
                    </div>
                  </div>
                </div>
                <div className="first-section-my-profile">
                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <FaPhoneAlt />
                      </div>
                      <input
                        className="form-control-accountInfo"
                        placeholder="Phone Number"
                        type="text"
                        value={
                          viewMoreDetail
                            ? viewMoreDetail?.brand_engagement
                              ? viewMoreDetail?.brand_engagement
                                  ?.user_phone_number
                              : viewMoreDetail?.fan_engagement
                                  ?.user_phone_number
                            : null
                        }
                        disabled
                        name="phoneno"
                      />
                    </div>
                  </div>
                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <MdEmail />
                      </div>
                      <input
                        className="form-control-accountInfo"
                        placeholder="Email"
                        type="text"
                        value={
                          viewMoreDetail
                            ? viewMoreDetail?.brand_engagement
                              ? viewMoreDetail?.brand_engagement?.user_email
                              : viewMoreDetail?.fan_engagement?.user_email
                            : null
                        }
                        disabled
                        name="email"
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div className="section-title-accountInfo">
                  Requested Details
                </div>
                <div className="fetc-st4">
                  <div className="viewmore-fan-brand-athlete">
                    <strong>
                      {viewMoreDetail?.brand_engagement
                        ? "Brand Partnership Type:"
                        : "Fan Partnership Type:"}{" "}
                    </strong>{" "}
                    {viewMoreDetail?.brand_engagement
                      ? viewMoreDetail?.brand_engagement?.fan_engagement_type
                      : viewMoreDetail?.fan_engagement?.fan_engagement_type}
                  </div>
                  <div className="viewmore-fan-brand-athlete">
                    <strong>Selected Platform:</strong>{" "}
                    {viewMoreDetail?.brand_engagement
                      ? viewMoreDetail?.brand_engagement?.social_media_platform
                      : viewMoreDetail?.fan_engagement?.social_media_platform}
                  </div>
                  <div className="viewmore-fan-brand-athlete">
                    <strong>Instructions for Athlete:</strong>{" "}
                    {viewMoreDetail?.brand_engagement
                      ? viewMoreDetail?.brand_engagement?.engagement_details
                      : viewMoreDetail?.fan_engagement?.engagement_details}
                  </div>
                </div>
                <hr />
                <div className="section-title-accountInfo">Pricing Details</div>
                <div className="fetc-st4">
                  <div className="viewmore-fan-brand-athlete">
                    <strong>Total:</strong> $
                    {viewMoreDetail?.transaction_amount}
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "10px",
            }}
          >
            <button
              className="engagement-modal-close-btn"
              onClick={handleCloseDetails}
            >
              Close
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default AthleteDashboard;
